import React, { Component } from "react";
import TextareaAutosize from "react-autosize-textarea";

class FoodListItem extends Component {
  constructor(props) {
    super();

    this.state = {
      // description: this.props.food.description,
      editing: false,
      answer: props && props.food ? props.food.answer : ""
    };
  }

  edit() {
    if (!this.props.canEdit) return;
    this.setState({
      editing: true
    });
  }

  update() {
    // update firebase

    this.setState({
      editing: false
    });

    if (this.state.answer) {
      this.props.update(this.props.food.name, this.state.answer);
    }
  }

  handleChange(e) {
    this.setState({
      answer: e.target.value
    });
  }

  keyDown(e) {
    if (e.keyCode === 13) this.update();
  }

  render() {
    // if there's a this.state then we're still updating
    const { isNew } = this.props.food;
    const { style } = this.props;

    let answer = (
      <p className="list-group-item-text" onClick={this.edit.bind(this)}>
        {this.props.food.answer}
      </p>
    );

    if (this.state.editing) {
      answer = (
        <TextareaAutosize
          className="form-control"
          value={this.state.answer}
          placeholder="I don't know if dogs can eat this."
          onChange={this.handleChange.bind(this)}
          onBlur={this.update.bind(this)}
          onKeyDown={this.keyDown.bind(this)}
          autoFocus
        />
      );
    }

    const classes = ["list-group-item"];
    if (isNew) classes.push("list-group-item-warning");
    return (
      <div className={classes.join(" ")} style={style}>
        <h4 className="list-group-item-heading">{this.props.food.name}</h4>
        {answer}
      </div>
    );
  }
}

export default FoodListItem;



/** WEBPACK FOOTER **
 ** ./src/FoodListItem.js
 **/